import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import css from './LowestPrice.module.scss';

interface Props {
  className?: string;
  lowestPrice: number;
}

const LowestPrice = (props: Props) => {
  const intl = useIntl();
  return (
    <span className={classNames(css.LowestPrice, props.className)}>
      <span className={css.LowestPrice__Emphasis}>
        {intl.formatNumber(props.lowestPrice)}
      </span>
      {intl.formatMessage({ id: 'merchants.common.lowestPrice.unit' })}
    </span>
  );
};

export default LowestPrice;
